 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"vendors-mobileTeamPage":"vendors-mobileTeamPage","mobileTeamPage":"mobileTeamPage","bulkEditor":"bulkEditor","channelStoriesPage-desktopChannelStories-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannel-766c021c":"channelStoriesPage-desktopChannelStories-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannel-766c021c","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507":"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507","channelStoriesPage":"channelStoriesPage","mobile404":"mobile404","mobileAboutPage":"mobileAboutPage","mobileApplyPage-mobileJoinPage-mobileLoginPage":"mobileApplyPage-mobileJoinPage-mobileLoginPage","mobileLoginPage":"mobileLoginPage","mobileChangePasswordPage":"mobileChangePasswordPage","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileExploreResultsPage-mobileSearchResultsPage":"mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileSearchResultsPage":"mobileSearchResultsPage","mobileFavoritesPage":"mobileFavoritesPage","mobileFilmFest":"mobileFilmFest","mobileGifVideoPage":"mobileGifVideoPage","mobileResetPasswordPage":"mobileResetPasswordPage","mobileTrendingPage":"mobileTrendingPage","vendors-gifEditPanel-gifMakerFinalize":"vendors-gifEditPanel-gifMakerFinalize","vendors-gifEditPanel":"vendors-gifEditPanel","desktopUploadFinalize-gifEditPanel-gifMakerFinalize":"desktopUploadFinalize-gifEditPanel-gifMakerFinalize","gifEditPanel":"gifEditPanel","vendors-mobileApplyPage-mobileGifMaker":"vendors-mobileApplyPage-mobileGifMaker","mobileApplyPage":"mobileApplyPage","vendors-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobile-3ed39632":"vendors-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobile-3ed39632","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage":"mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","mobileChannelSearchPage":"mobileChannelSearchPage","vendors-gifMakerVideoTrim-mobileGifMaker":"vendors-gifMakerVideoTrim-mobileGifMaker","vendors-gifMakerFinalize-mobileGifMaker":"vendors-gifMakerFinalize-mobileGifMaker","mobileGifMaker":"mobileGifMaker","vendors-mobileDashboard":"vendors-mobileDashboard","mobileDashboard":"mobileDashboard","vendors-mobileJoinPage":"vendors-mobileJoinPage","mobileJoinPage":"mobileJoinPage","vendors-reactGiphyTV":"vendors-reactGiphyTV","vendors-showdown":"vendors-showdown","vendors-storybookModal":"vendors-storybookModal","storybookModal":"storybookModal","gifDetailMedia":"gifDetailMedia","desktopUploadFinalize":"desktopUploadFinalize","gifMakerSlideshow":"gifMakerSlideshow","gifMakerFinalize-gifMakerVideoTrim":"gifMakerFinalize-gifMakerVideoTrim","gifMakerFinalize":"gifMakerFinalize","gifMakerVideoTrim":"gifMakerVideoTrim","appsLanding":"appsLanding","artists":"artists","desktopChannelStories":"desktopChannelStories","curationStation":"curationStation","desktopStory":"desktopStory","desktopTrending":"desktopTrending","desktopTrendingVideos":"desktopTrendingVideos","filmFest":"filmFest","homebase":"homebase","homepageBeta":"homepageBeta"}[chunkId]||chunkId) + "." + {"0":"342b5cb9","1":"11c892b9","vendors-mobileTeamPage":"8f6baba0","mobileTeamPage":"91f8b9bc","bulkEditor":"a357efc3","channelStoriesPage-desktopChannelStories-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannel-766c021c":"8b8d5dae","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507":"08986f0a","channelStoriesPage":"099cdb7c","mobile404":"50d995c3","mobileAboutPage":"3e42ec50","mobileApplyPage-mobileJoinPage-mobileLoginPage":"7335825a","mobileLoginPage":"cf4ac76b","mobileChangePasswordPage":"55053586","mobileExploreCategoryPage":"78df3a6f","mobileExploreResultsPage-mobileSearchResultsPage":"11312fe4","mobileExploreResultsPage":"64da85e1","mobileSearchResultsPage":"1759c8e1","mobileFavoritesPage":"03853dd7","mobileFilmFest":"241cef84","mobileGifVideoPage":"7cf97411","mobileResetPasswordPage":"9d9ed6d6","mobileTrendingPage":"8aff7f38","vendors-gifEditPanel-gifMakerFinalize":"889cc3a4","vendors-gifEditPanel":"d7a6e1e8","desktopUploadFinalize-gifEditPanel-gifMakerFinalize":"df8de471","gifEditPanel":"c120ed6f","vendors-mobileApplyPage-mobileGifMaker":"8c5ae3fd","mobileApplyPage":"ad546f4e","vendors-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobile-3ed39632":"607084ee","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage":"308e9a30","mobileChannelBranchPage":"7bcbfe0c","mobileChannelLeafPage":"8afce100","mobileChannelListPage":"2e425541","mobileChannelPage":"0203114b","mobileChannelSearchPage":"1b9cf09f","vendors-gifMakerVideoTrim-mobileGifMaker":"be84ef38","vendors-gifMakerFinalize-mobileGifMaker":"56f90a98","mobileGifMaker":"7fec6efe","vendors-mobileDashboard":"3c3e059e","mobileDashboard":"dcb12e32","vendors-mobileJoinPage":"bf349475","mobileJoinPage":"51d56f6e","vendors-reactGiphyTV":"a2abe34e","vendors-showdown":"3c6c3832","vendors-storybookModal":"91e0c718","storybookModal":"7454428d","gifDetailMedia":"3969cd09","desktopUploadFinalize":"61fe6ba5","gifMakerSlideshow":"631a6f09","gifMakerFinalize-gifMakerVideoTrim":"726b8306","gifMakerFinalize":"3b9ab05b","gifMakerVideoTrim":"26010b55","appsLanding":"c268df66","artists":"330dc6cf","desktopChannelStories":"efb026f2","curationStation":"17d4cfec","desktopStory":"83c7fe03","desktopTrending":"990ee356","desktopTrendingVideos":"f623462e","filmFest":"f26a3adf","homebase":"179edd3a","homepageBeta":"6e6d00e2"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
